import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import { Box } from "@material-ui/core/";

import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    table: {
        boxSizing: "border-box",
        paddingBottom:'40px',
        border:'1px solid #BDBBBB'
    },
    tableHeader: {
        textDecoration: "underline",
        padding: "20px 0 10px 25px",
        fontSize: "20px",
        fontWeight: 500,
    },
    tableSubHeader: {
        padding: "20px 0 30px 25px",
        fontSize: "16px",
    },
    roleTable: {
        height:'100%',
        margin:'0px 25px',
        border: "1px solid #BDBBBB ",
        borderRadius: "7px",
    },
    roleTableHeader: {
        height: "35px",
        color: "#fff",
        padding: "7px 20px",
        backgroundColor: "#001128",
        borderRadius:'6px 6px 0px 0px'
    },
    botTable: {
        padding:30,
        height: 100
    }
    
});


function BotDetails() {
    const { t } = useTranslation();

    const classes = useStyles();
    return (
        <Paper className={classes.table} data-test="bot-detail-comp">
            <Box className={classes.tableHeader}>
                {t("CONTENT.BOTS.BOT-DETAILS")}
            </Box>
            <Box className={classes.tableSubHeader}>
                {t('CONTENT.BOTS.BOT-SUB-HEADER')}
            </Box>
            <Paper className={classes.roleTable}>
                <Box className={classes.roleTableHeader}>{t('CONTENT.BOTS.PURCHASED-BOTS')}</Box>
                <Box className={classes.botTable}>
                {t('CONTENT.BOTS.NON-BOT')}
                </Box>
            </Paper>
        </Paper>
        
    );
}

export default BotDetails;
